// @ts-nocheck
import { filter, values } from 'lodash';
import { sentenceCase } from 'change-case';
import { useEffect, useState, useCallback } from 'react';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
// material
import {
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  TableHead,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  ListSubheader,
  TextField,
  InputAdornment,
  Box,
  OutlinedInput,
  ListItemText,
} from '@mui/material';

// components
import Page from '../../components/Page';
import Label from '../../components/Label';
import Scrollbar from '../../components/Scrollbar';
import Iconify from '../components/Iconify';
import SearchNotFound from '../../components/SearchNotFound';
import { BookingListHead, BookingListToolbar, BookingMoreMenu } from '../../sections/@dashboard/bookings';
// mock
import USERLIST from '../_mock/user';
import { cancellations as CANCELLATIONS } from '../../_mock/bookings';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { getAuthDetails } from '../../store/state/authSlice';
import {
  useApproveCancelBookingByAdminMutation,
  useGetAllBookingDetailBySearchCriteriaMutation,
} from '../../store/api/bookingsApi';
import { getbookingSpaces, getBookingTotalRecords, setBookings } from '../../store/state/bookingSlice';
import toast from 'react-hot-toast';
import { useRefundMutation } from '../../store/api/StripeApi';
import Loading from '../../components/Loading';
import { SelectDatepicker } from 'react-select-datepicker';
import { styled } from '@mui/material/styles';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'Date', label: 'Date', alignRight: false },
  { id: 'OccupancyatDayStart', label: 'Occupancy at Day Start', alignRight: false },
  { id: ' NoOfCheckins ', label: 'No Of Checkins', alignRight: false },
  { id: 'NoOfCheckouts ', label: ' No Of Checkouts', alignRight: false },
  { id: ' OccupancyatDayEnd ', label: 'Occupancy at Day End', alignRight: false },
  { id: '' },
];

const ResponsiveBox = styled('div')(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: '20px',
  },
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
  },
}));

const ButtonBox = styled('div')(({ theme }) => ({
  padding: theme.spacing(1),
  [theme.breakpoints.down('sm')]: {
    width: '275px',
    marginRight: '12px',
  },
}));

const variants = [
  {
    id: 3,
    name: 'Voucher',
    slug: 'voucher',
    type: 'Main',
    locale: 'en',
    created_at: '2021-11-15T08:27:23.000Z',
    updated_at: '2021-11-15T08:27:23.000Z',
    cover: null,
  },
  {
    id: 1,
    name: 'Top Up',
    slug: 'top-up',
    type: 'Main',
    locale: 'en',
    created_at: '2021-11-15T08:26:44.000Z',
    updated_at: '2021-11-15T08:26:44.000Z',
    cover: null,
  },
  {
    id: 2,
    name: 'Game Key',
    slug: 'game-key',
    type: 'Main',
    locale: 'en',
    created_at: '2021-11-15T08:27:03.000Z',
    updated_at: '2021-11-15T08:27:03.000Z',
    cover: null,
  },
  {
    id: 12,
    name: 'Other',
    slug: 'other',
    type: 'SubMain',
    locale: 'en',
    created_at: '2021-11-15T08:30:50.000Z',
    updated_at: '2021-11-15T08:30:50.000Z',
    cover: null,
  },
  {
    id: 11,
    name: 'Nintendo',
    slug: 'nintendo',
    type: 'SubMain',
    locale: 'en',
    created_at: '2021-11-15T08:30:22.000Z',
    updated_at: '2021-11-15T08:30:22.000Z',
    cover: null,
  },
  {
    id: 10,
    name: 'Xbox',
    slug: 'xbox',
    type: 'SubMain',
    locale: 'en',
    created_at: '2021-11-15T08:30:08.000Z',
    updated_at: '2021-11-15T08:30:08.000Z',
    cover: null,
  },
];
// ----------------------------------------------------------------------
function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}
function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user.id.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function AdminStatistics() {
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const currentUser = useAppSelector(getAuthDetails);
  const [customerName, setcustomerName] = useState('');
  const [getAllBookingDetailBySearchCriteria, getAllResponse] = useGetAllBookingDetailBySearchCriteriaMutation();
  const [approveCancelBookingByAdmin, adminApproveResponse] = useApproveCancelBookingByAdminMutation();
  const BookingData = useAppSelector(getbookingSpaces);
  const [cancellations, setAllCancellations] = useState();
  const token = JSON.parse(localStorage.getItem('login')).token || null;
  const dispatch = useAppDispatch();
  const bookingTotalRecords = useAppSelector(getBookingTotalRecords);
  const [refundDetail, setRefundDeatil] = useState();
  const [value, setValue] = useState<Date | null>(new Date());
  const onDateChange = useCallback((date: Date) => {
    setValue(date);
  }, []);

  const [variantName, setVariantName] = React.useState([
    {
      id: 11,
      name: 'Nintendo',
      slug: 'nintendo',
      type: 'SubMain',
      locale: 'en',
      created_at: '2021-11-15T08:30:22.000Z',
      updated_at: '2021-11-15T08:30:22.000Z',
      cover: null,
    },
    {
      id: 10,
      name: 'Xbox',
      slug: 'xbox',
      type: 'SubMain',
      locale: 'en',
      created_at: '2021-11-15T08:30:08.000Z',
      updated_at: '2021-11-15T08:30:08.000Z',
      cover: null,
    },
  ]);

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;

    const filterdValue = value.filter((item) => variantName.findIndex((o) => o.id === item.id) >= 0);

    let duplicatesRemoved = value.filter((item, itemIndex) =>
      value.findIndex((o, oIndex) => o.id === item.id && oIndex !== itemIndex)
    );

    let duplicateRemoved = [];

    value.forEach((item) => {
      if (duplicateRemoved.findIndex((o) => o.id === item.id) >= 0) {
        duplicateRemoved = duplicateRemoved.filter((x) => x.id === item.id);
      } else {
        duplicateRemoved.push(item);
      }
    });

    setVariantName(duplicateRemoved);
  };

  const getCancellationDetailsAsync = async (flag, offset, sortOrder, newPage, columnName, customerName) => {
    await getAllBookingDetailBySearchCriteria({
      token: token,
      payload: {
        columnName: columnName,
        offset: offset,
        page: newPage,
        orderBy: sortOrder,
        flag: flag,
        customerName: customerName,
      },
    });
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
    getCancellationDetailsAsync('CANCEL_BOOKING', rowsPerPage, isAsc ? 'desc' : 'asc', 0, 'id', '');
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = cancellations.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  useEffect(() => {
    getCancellationDetailsAsync('CANCEL_BOOKING', rowsPerPage, orderBy, page, 'id', '');
  }, []);

  useEffect(() => {
    if (getAllResponse.isSuccess) {
      dispatch(setBookings(getAllResponse.data));
    }
    if (getAllResponse.isError) {
      let errorData: any = getAllResponse.error;
      let msg: any = errorData?.data?.serviceErrors[0]?.msg;
      toast.error('Something went wrong ' + msg || '');
    }
  }, [getAllResponse.isSuccess, getAllResponse.isError]);

  useEffect(() => {
    if (BookingData) {
      setAllCancellations(BookingData);
    }
  }, [BookingData]);

  useEffect(() => {
    if (adminApproveResponse.isSuccess) {
      setRefundDeatil(adminApproveResponse.data);
      getCancellationDetailsAsync('CANCEL_BOOKING', rowsPerPage, orderBy, page, 'id', '');
      if (adminApproveResponse.isError) {
        let errorData: any = adminApproveResponse.error;
        let msg: any = errorData?.data?.serviceErrors[0]?.msg;
        toast.error('Something went wrong ' + msg || '');
      }
      toast.success('Booking Cancelled Successfully');
    }
  }, [adminApproveResponse.isSuccess, adminApproveResponse.isError]);


  const handleChangePage = async (event, newPage) => {
    setPage(newPage);
    await getCancellationDetailsAsync('CANCEL_BOOKING', rowsPerPage, orderBy, newPage, 'id', '');
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
    getCancellationDetailsAsync('CANCEL_BOOKING', parseInt(event.target.value, 10), orderBy, 0, 'id', '');
  };

  const filteredUsers = cancellations ? cancellations : [];
  const isUserNotFound = filteredUsers.length === 0;

  return (
    <Page title="Statistics">
      <Container>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
          <Typography variant="h4" gutterBottom>
            Statistics
          </Typography>
        </Stack>

        <Card>
          <ResponsiveBox style={{ display: 'flex' }}>
            <Box style={{ marginLeft: '20px', marginTop: '33px' }}>
              <div>
                <FormControl>
                  <Select
                    labelId="demo-multiple-checkbox-label"
                    multiple
                    value={variantName}
                    onChange={handleChange}
                    renderValue={(selected) => selected.map((x) => x.name).join(', ')}
                    style={{ width: '250px', marginTop: '8px' }}
                  >
                    {variants.map((variant) => (
                      <MenuItem key={variant.id} value={variant}>
                        <Checkbox checked={variantName.findIndex((item) => item.id === variant.id) >= 0} />
                        <ListItemText primary={variant.name} />
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>
            </Box>
            <Box>
              <SelectDatepicker selectedDate={value} onDateChange={onDateChange} order="month/year" hideLabels="true" />
            </Box>
            <ButtonBox style={{ marginLeft: '10px', marginTop: '35px' }}>
              <Stack>
                <Button
                  style={{
                    width: '100%',
                    borderColor: 'blue',
                    padding: '10px',
                    marginLeft: '10px',
                    alignItems: 'center',
                  }}
                  onClick={() => {
                    // handleSubmit();
                  }}
                  variant="contained"
                >
                  Submit
                </Button>
              </Stack>
            </ButtonBox>
          </ResponsiveBox>

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <BookingListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={cancellations?.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {filteredUsers.map((row) => {
                    const {
                      id,
                      name,
                      bookingCode,
                      role,
                      status,
                      avatarUrl,
                      isVerified,
                      parkingSlotRespDTO,
                      parkingSpaceLocationRespDTO,
                      serviceProviderDetailResponseDTO,
                      customerDetailResponseDTO,
                      parkingLocationId,
                      serviceProviderId,
                      customerId,
                      bookingAmount,
                      cancellationReasonName,
                    } = row;
                    const isItemSelected = selected.indexOf(name) !== -1;

                    return (
                      <TableRow
                        hover
                        key={id}
                        tabIndex={-1}
                        role="checkbox"
                        selected={isItemSelected}
                        aria-checked={isItemSelected}
                      >
                        {/* <TableCell align="left">{bookingCode}</TableCell>
                        <TableCell align="left">{customerDetailResponseDTO?.name}</TableCell>
                        <TableCell align="left">
                          {parkingSpaceLocationRespDTO?.serviceProviderDetailResponseDTO?.name}
                        </TableCell>
                        <TableCell align="left">{parkingSpaceLocationRespDTO?.name}</TableCell> */}
                        {/* <TableCell align="left">
                          {capitalize(parkingSpaceLocationRespDTO?.name)}-{parkingSlotRespDTO?.slotId}
                        </TableCell>
                        <TableCell align="left">{parkingSlotRespDTO?.slotId}</TableCell> */}
                        {/* <TableCell align="left">${bookingAmount}</TableCell>
                        <TableCell align="left">{cancellationReasonName}</TableCell>
                        <TableCell align="left">{isVerified ? 'Verified' : 'Not Verified'}</TableCell>
                        <TableCell align="left">
                          {status === 'UNPAID' ? (
                            <Button variant="contained">Approve</Button>
                          ) : (
                            <Button
                              variant="contained"
                              color="success"
                              disabled={currentUser.categoryTypeId == 'UTSP' ? false : true}
                            >
                              Approve
                            </Button>
                          )}
                        </TableCell>
                        <TableCell align="left">
                          {status === 'UNPAID' ? (
                            <Button variant="contained">Approve</Button>
                          ) : (
                            <Button
                              variant="contained"
                              color="success"
                              disabled={currentUser.categoryTypeId == 'UTSA' ? false : true}
                              onClick={() => {
                                approveCancelBookingByAdmin({
                                  token: token,
                                  bookingId: id,
                                  customerId: customerId,
                                  parkingSpaceLocationId: parkingLocationId,
                                  serviceProviderId: serviceProviderId,
                                });
                              }}
                            >
                              Approve
                            </Button>
                          )}
                        </TableCell> */}
                      </TableRow>
                    );
                  })}
                </TableBody>

                {isUserNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={8} sx={{ py: 3 }}>
                        <SearchNotFound searchQuery={filterName} />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={bookingTotalRecords || 0}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Card>
      </Container>
      {getAllResponse.isLoading || adminApproveResponse.isLoading ? <Loading /> : null}
    </Page>
  );
}
